import React from 'react';
import { choose } from '../../utils/platform';
import { useShareApp } from './useShareApp';
import ShareAppDesktop from './ShareApp.desktop';
import ShareAppMobile from './ShareApp.mobile';

const ShareAppView = choose(ShareAppDesktop, ShareAppMobile);

export default function ShareApp() {
  const vm = useShareApp();
  return <ShareAppView vm={vm} />;
}
